import React from 'react';
import axios from 'axios';
import { stripMarkdown } from '../../utils/markdownUtil';

const PRIORITY_STYLES = {
  Low: 'bg-green-100 text-green-700',
  Medium: 'bg-yellow-100 text-yellow-700',
  High: 'bg-orange-100 text-orange-700',
  Urgent: 'bg-red-100 text-red-700',
};

const TemplateGallery = ({ templates = [], onSelect, onDelete }) => {
  const handleDelete = async (templateId) => {
    if (!window.confirm('Delete this template?')) return;
    const token = localStorage.getItem('token');
    try {
      await axios.delete(`/api/templates/${templateId}`, {
        headers: { 'x-auth-token': token },
      });
      if (onDelete) onDelete(templateId);
    } catch (err) {
      console.error('Error deleting template:', err);
    }
  };

  if (!templates || templates.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        <p className="text-xs mt-1">Create your first template to get started</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {templates.map((t) => {
        const priorityClass = PRIORITY_STYLES[t.defaultPriority] || PRIORITY_STYLES.Medium;
        const strippedDesc = stripMarkdown(t.descriptionTemplate);
        const descPreview = strippedDesc
          ? strippedDesc.slice(0, 60) + (strippedDesc.length > 60 ? '...' : '')
          : '';

        return (
          <div
            key={t._id}
            className="group p-4 border border-gray-100 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-800 hover:border-primary-blue dark:hover:border-blue-500 hover:shadow-md transition-all cursor-pointer relative"
            onClick={() => onSelect && onSelect(t)}
          >
            <div className="flex items-start justify-between mb-2">
              <h3 className="font-black text-gray-900 dark:text-gray-100 text-sm uppercase tracking-tight leading-tight pr-2">
                {t.name}
              </h3>
              <span
                className={`text-[10px] font-black px-2 py-0.5 rounded uppercase tracking-tighter flex-shrink-0 ${priorityClass}`}
              >
                {t.defaultPriority || 'Medium'}
              </span>
            </div>

            {descPreview && (
              <p className="text-xs text-gray-500 dark:text-gray-400 italic leading-relaxed mb-3">
                "{descPreview}"
              </p>
            )}

            {t.defaultLabels && t.defaultLabels.length > 0 && (
              <div className="flex flex-wrap gap-1 mb-3">
                {t.defaultLabels.map((label, i) => (
                  <span
                    key={i}
                    className="text-[9px] font-bold bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1.5 py-0.5 rounded uppercase"
                  >
                    {label}
                  </span>
                ))}
              </div>
            )}

            <div className="flex justify-end">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(t._id);
                }}
                className="text-red-400 dark:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-black uppercase tracking-widest hover:text-red-600 dark:hover:text-red-400"
              >
                Delete
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TemplateGallery;
